import React from "react";
import { Document, Page, StyleSheet, Font } from "@react-pdf/renderer"
import OnlyTicket from "./OnlyTicket";

Font.register({
	family: 'Northlane Two',
	src: '/fonts/Northlane/Northlane-Two.ttf',
	fontWeight: 'normal',
});

export default function MultipleTickets({ tickets }) {
	const widthTicket = 670;
	const heightTicket = 420;

	return (
		<Document>
			{tickets?.map((ticket, index) => (
				<Page
					size={{ width: widthTicket, height: heightTicket }}
					key={index}
				>
					<OnlyTicket ticket={ticket} />
				</Page>
			))}
		</Document>
	);
}
